// Consider having the data type exported her as well
const analytic = (state) => state.analytic;
const items = (state) => state.analytic?.items;

export { analytic, items };
